import * as React from 'react';
import { Route } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import { useSelector } from 'react-redux';
import Container from '@mui/material/Container';
import { ComponentClass, FC, ReactElement } from 'react';
import { RouteProps } from 'react-router';
import { ContentPage, TContentState } from '../../types/Content';
import { IAppState } from '../../store/Store';
import makeStyles from '@mui/styles/makeStyles';
import { Theme, useMediaQuery, useTheme } from '@mui/material';

interface IDynamicRouteParams extends RouteProps {
  component: ComponentClass | FC;
  navbarText?: string | ReactElement<any>;
  showBackButton?: boolean;
  pageType?: ContentPage;
  hideNavbar?: boolean;
  hideAccountMenu?: boolean;
  customIcon?: ComponentClass | FC;
  disableLogoLink?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  mainContainer: {
    paddingBottom: '30px',
    paddingTop: '75px',
  },
}));

export const DynamicRoute = ({
  component,
  navbarText,
  showBackButton,
  pageType,
  hideNavbar,
  hideAccountMenu,
  customIcon,
  disableLogoLink,

  ...rest
}: IDynamicRouteParams) => {
  const classes = useStyles({});
  const contentState: TContentState = useSelector<IAppState, TContentState>(
    (state) => state.contentState
  );
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('md'));
  let pageTitle = navbarText;
  if (pageType) {
    pageTitle = contentState?.data?.name;
  }
  if (
    contentState.currentPageTitle?.title &&
    contentState.currentPageTitle.url === window.location.pathname
  ) {
    pageTitle = contentState.currentPageTitle.title;
  }

  const routeComponent = (props: any) => (
    <>
      {pageTitle && !hideNavbar && (
        <Navbar
          text={pageTitle ? pageTitle : ''}
          visible={true}
          showBackButton={showBackButton}
          hideAccountMenu={hideAccountMenu}
          customIcon={customIcon}
          isFrontpage={pageType === ContentPage.FRONTPAGE}
          disableLogoLink={disableLogoLink}
        />
      )}
      <Container
        component='main'
        maxWidth={isXs ? 'xs' : 'lg'}
        className={classes.mainContainer}
      >
        {React.createElement(component, props)}
      </Container>
    </>
  );
  return <Route {...rest} render={routeComponent} />;
};
